var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress border border-white bg-transparent"},[_c('div',{staticClass:"progress-bar me-auto",class:_vm.progressBarColor,style:({'width':_vm.player.strength + '%'}),attrs:{"role":"progressbar"}},[_vm._v(" "+_vm._s(_vm._f("float")(_vm.player.strength))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }